import React from "react";
export default () => (
  <div className="full-screen flex-container flex-center">努力加载中...</div>
);
